import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './table.css'
import {
    TablePagination,
} from "@material-ui/core";
import { showText } from '../../helpers/textValidation';
import { useEffect } from 'react';

const TableWithoutPagination = ({ tableData, pageFor = "default" }) => {

    let { header, rows } = tableData;

    return (

        <Paper>
            <TableContainer component={Paper} style={{ maxHeight: "500px", overflowY: "auto" }}>
                <Table stickyHeader sx={{ width: "100%" }} aria-label="simple table">
                    <TableHead style={{ backgroundColor: "#2963ad" }}>
                        <TableRow style={{ backgroundColor: "#2963ad" }}>
                            {header?.map((col) => (
                                <TableCell style={{ color: "white", backgroundColor: "#2963ad", top: 0, zIndex: 2 }}>
                                    <p style={{ whiteSpace: "nowrap" }}>
                                        {col}
                                    </p>
                                </TableCell>
                            ))
                            }
                        </TableRow>
                    </TableHead>
                    {rows?.length ?
                        <TableBody>
                            {rows
                                ?.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        {pageFor === "broadcastMessage"
                                            ? row?.map((cols, index) => (
                                                <TableCell component="th" scope="row">
                                                    <p style={cols?.style}>
                                                        {showText(cols.value)}
                                                    </p>
                                                </TableCell>
                                            ))
                                            : row?.map((cols, index) => (
                                                <TableCell component="th" scope="row">
                                                    <p style={{ whiteSpace: "nowrap" }}>
                                                        {showText(cols)}
                                                    </p>
                                                </TableCell>
                                            ))
                                        }
                                    </TableRow>
                                ))}

                        </TableBody>
                        : <></>}
                </Table>
                {!rows?.length && <p className='notFoundTable'>No data Found!</p>}

            </TableContainer>
        </Paper>

    )
}

export default TableWithoutPagination